import React from "react";
import { useField } from 'formik';
import { FormLabel, Input } from "@chakra-ui/react";

const CustomFormInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <>
            <FormLabel htmlFor={props.id || props.name} pt='8px'>{label}</FormLabel>
            <Input className='text-input' {...field} {...props} mt={[0, "4px !important"]}/>
            {meta.touched && meta.error ? (
                <div className='error'>{meta.error}</div>
            ) : null}
        </>
    )
}

export default CustomFormInput;